import React, { useEffect, useState } from "react";
import HomeService from "../../Services/HomeService";

export default function Footerlan() {
  const [activeTab, setActiveTab] = useState("");
  const [footerData, setFooterData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFooterData = async () => {
    try {
      setLoading(true);
      const res = await HomeService?.getFooterData();
      console.log("Footer data", res);

      if (res?.status) {
        setFooterData(res?.data);

        if (res.data && res.data.length > 0) {
          const firstTabId = res.data[0].sectionName
            .toLowerCase()
            .replace(/\s+/g, "");
          setActiveTab(firstTabId);
        }
      } else {
        console.log("Failed to fetch footer data:", res);
      }
    } catch (error) {
      console.log("Error fetching footer data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFooterData();
  }, []);

  const processTabData = () => {
    const processedData = {};

    footerData.forEach((tab) => {
      const tabId = tab.sectionName.toLowerCase().replace(/\s+/g, "");

      const columns = [];
      const itemsPerColumn = Math.ceil(tab.subHeadings.length / 3);

      for (let i = 0; i < 3; i++) {
        const startIndex = i * itemsPerColumn;
        const endIndex = startIndex + itemsPerColumn;
        columns.push(tab.subHeadings.slice(startIndex, endIndex));
      }

      processedData[tabId] = {
        heading: tab.heading,
        columns: columns,
        originalData: tab,
      };
    });

    return processedData;
  };

  const tabData = processTabData();

  if (loading) {
    return (
      <div className="footerlan-container">
        <div className="footerlan_under_section">
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading footer data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!footerData.length) {
    return (
      <div className="footerlan-container">
        <div className="footerlan_under_section">
          <div className="text-center py-5">
            <p>No footer data available</p>
            <button onClick={fetchFooterData} className="btn btn-primary mt-2">
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (!activeTab && footerData.length > 0) {
    const firstTabId = footerData[0].sectionName
      .toLowerCase()
      .replace(/\s+/g, "");
    setActiveTab(firstTabId);
    return null;
  }

  return (
    <div className="footerlan-container">
      <div className="footerlan_under_section">
        <div className="footerlan-tabs">
          {footerData?.map((tab) => {
            const tabId = tab.sectionName.toLowerCase().replace(/\s+/g, "");

            return (
              <div
                key={tab._id}
                className={`footerlan_tab-item ${
                  activeTab === tabId ? "active" : ""
                }`}
                onClick={() => setActiveTab(tabId)}
              >
                {tab?.sectionName}
              </div>
            );
          })}
        </div>

        {activeTab && tabData[activeTab] && (
          <div className="footerlan_tab-content">
            <h4 className="footerlan_tab-main-heading">
              {tabData[activeTab].heading}
            </h4>
            <div className="footerlan_projects-grid">
              {tabData[activeTab].columns.map((col, index) => (
                <ul key={index}>
                  {col.map((item, idx) => (
                    <li key={idx}>
                      <a href="/profile">{item}</a>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
